import { useEffect, useState } from "react";
import { IUpdateLicense } from "../UpdateLicense/interface";
import { Constants } from "../../../Constants/Constants";
import classNames from "classnames";
import "./DeviceSettings.scss";
import { useSharedState } from "../../../../components/services/WindowSizeService";
import FormBuilder from "../../../FormBuilder/FormBuilder";
import { authorizationService } from "../../../api_services/authorizationService";
import { alertService } from "../../Services/alertService";
import { IModuleConfig } from "./interface";
import Loader from "../../Loader/Loader";
import { endSession, getURLDataMethod, noAccessMessage } from "../../../Utils/Utils";
const DeviceSettings = (props: IUpdateLicense) => {
    const { onClose, onSubmit } = props;
    const windowSize$ = useSharedState();
    const [activeSetting, setActiveSetting] = useState<string>();
    const [finalSubmit, setFinalSubmit] = useState<boolean>(false);
    const [moduleConfigData, setModuleConfigData] = useState<IModuleConfig>();
    const [rowsAPI, setRowsAPI] = useState<any>([]);
    const [loader, setLoader] = useState<boolean>(true);
    const [submitData, setSubmitData] = useState<any>({
        // "meta": [],
        "ADC": {
        },
        "Network": {},
        "advancedOptions": {}
    });
    const [allRequiredFields, setAllRequiredFields] = useState<any>({
        "Network": [],
        "advancedOptions": []
    }
    );
    // const [modu]
    const sunMenuItems = [
        { keyName: 'meta', Label: 'Meta' },
        { keyName: 'ADC', Label: 'ADC Config' },
        { keyName: 'Network', Label: 'Network' },
        { keyName: 'advancedOptions', Label: 'Advanced Options' },
    ];

    useEffect(() => {
        defaultSubmitData()
    }, [moduleConfigData])

    const defaultSubmitData = () => {
        submitData["ADC"] = moduleConfigData?.ADC;
        setSubmitData(submitData);
    }

    // const [url, setUrl] = useState<any>(localStorage.getItem("url"));
    // let URL_Data = url.split('&');
    // let payLoad: any = {
    //     firmware_version: URL_Data[0],
    //     device_type: URL_Data[1],
    //     device_id: URL_Data[2],
    // };

    let payLoad: any = getURLDataMethod();

    let mainResData =
    {
        "meta": [
            {
                "key": "old_uploader_type",
                "label": "Old Upload",
                "value": "csv"
            },
            {
                "key": "device_id",
                "label": "Device ID",
                "value": "SCN101L_267"
            },
            {
                "key": "board_version",
                "label": "Board Version",
                "value": 2.0
            }
        ],
        "ADC": {
            "ADC1": {
                "rh": 26235,
                "rl": 5293
            },
            "ADC2": {
                "rh": 26367,
                "rl": 5300
            },
            "ADC3": {
                "rh": 26383,
                "rl": 5299
            },
            "ADC4": {
                "rh": 26352,
                "rl": 5291
            }
        },
        "Network": [],
        "advancedOptions": [
            {
                "key": "old_uploader_type",
                "label": "Old Uploader Type (Enable/Disable)",
                "type": "checkBox",
                "tooltip": true,
                "tip": "Check",
                "required": true,
                "defaultValue": true
            },
            {
                "key": "old_data_uploader_format",
                "label": "Old Upload Data Format",
                "type": "select",
                "placeholder": "Please Select",
                "tooltip": true,
                "tip": "Check",
                "required": true,
                "defaultValue": "csv",
                "options": [
                    {
                        "label": "JSON",
                        "value": "json"
                    },
                    {
                        "label": "CSV",
                        "value": "csv"
                    }
                ]
            },
            {
                "key": "acquisition",
                "label": "Acquisition",
                "type": "checkBox",
                "tooltip": true,
                "tip": "Check",
                "required": true,
                "defaultValue": false,
                "dependantDisableKeys": ["failureCount"]
            },
            {
                "key": "failureCount",
                "label": "Failure Count",
                "type": "input",
                "placeholder": "Please Enter",
                "dataType": "number",
                "required": true,
                "tooltip": true,
                "tip": "Check",
                "disableDependency": "acquisition"
            }

        ]
    }


    useEffect(() => {
        getModuleConfigData();
        setActiveSetting(sunMenuItems[0].keyName)
    }, [])

    // useEffect(() => {
    //     console.log(inputFormData);
    //     if (activeSetting === Constants.Network) {
    //         submitData["Network"] = inputFormData;
    //     }
    //     else if (activeSetting === Constants.AdvancedOptions) {
    //         submitData["advancedOptions"] = inputFormData;
    //     }
    //     setSubmitData(submitData);

    // }, [inputFormData])

    // useEffect(() => {
    //     console.log(requiredFieldData);
    //     if (activeSetting === Constants.Network) {
    //         allRequiredFields["Network"] = requiredFieldData;
    //     }
    //     else if (activeSetting === Constants.AdvancedOptions) {
    //         allRequiredFields["advancedOptions"] = requiredFieldData;
    //     }
    //     setAllRequiredFields(allRequiredFields);
    // }, [requiredFieldData, requiredFieldData?.length])

    const carrySetRequiredFieldData = (data?: any, parent?: any) => {
        if (data) {
            allRequiredFields[parent] = data;
        }
        setAllRequiredFields(allRequiredFields);
    }

    const carrySetInputFormData = (data?: any, parent?: any) => {
        if (data) {
            submitData[parent] = data;
        }
        setSubmitData(submitData);
    }

    const getModuleConfigData = async () => {
        const payloadData = JSON.parse(JSON.stringify(payLoad));
        if (payloadData && payloadData['firmware_version']) {
            const device = payloadData['device_type'].split('iLens-')[1];
            try {
                return await authorizationService.getModuleConfigData("ModuleConfig", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            setLoader(false);
                            let response = JSON.parse(JSON.stringify(res.body.data));
                            Object.entries(response);
                            setModuleConfigData(response);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    const updateModuleConfigData = async () => {
        if (payLoad) {
            const payloadData = JSON.parse(JSON.stringify(payLoad));
            if (submitData) {
                payloadData["settings"] = submitData;
            }
            if (payloadData && payloadData['firmware_version']) {
                const device = payloadData['device_type'].split('iLens-')[1];
                try {
                    return await authorizationService.updateModuleConfigData("ModuleConfig", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                let response = JSON.parse(JSON.stringify(res.body));
                                setLoader(true);
                                getModuleConfigData()
                                alertService.serviceSuccessMessage(response?.message)
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            alertService.serviceErrorMessage(res.body?.message)
                            console.log("error");
                        }
                    })
                } catch (err: any) {
                    console.log(err);
                }
            }
        }
    }

    const config = [
        {
            "key": "internetInterface",
            "label": "Internet Interface",
            "type": "select",
            "placeholder": "Please Select",
            "tooltip": true,
            "tip": "Check",
            "required": true,
            "defaultValue": "WiFi",
            "options": [
                {
                    "label": "SIM7600",
                    "value": "SIM7600",
                },
                {
                    "label": "WiFi",
                    "value": "WiFi"
                }
            ],
            "dependencyList": {
                "SIM7600": [
                    {
                        "key": "dynamicAddAPIs",
                        "label": "Add",
                        "type": "addDynamicFields",
                        "tooltip": true,
                        "tip": "Add the APN's",
                        "required": true,
                        "dynamicFields": [
                            {
                                "key": "label",
                                "label": "label",
                                "placeholder": "Label"
                            },
                            {
                                "key": "value",
                                "label": "value",
                                "placeholder": "Value"
                            }
                        ],
                        "dynamicFieldValue": [
                            {
                                "label": "IND airtel airtel",
                                "value": "airtelgprs.com"
                            },
                            {
                                "label": "Jio 4G Jio 4G",
                                "value": "jionet",
                            },
                            {
                                "label": "Vi India VIL",
                                "value": "www"
                            },
                            {
                                "label": "Vi India Vi India",
                                "value": "www"
                            },
                            {
                                "label": "airtel airtel",
                                "value": "airtelgprs.com"
                            }
                        ]
                    }
                ],
                "WiFi": [
                    {
                        "key": "ssid",
                        "label": "SSID",
                        "type": "input",
                        "restrictSpecialCharacters": true,
                        "dataType": "text",
                        "placeholder": "Please Enter",
                        "required": true,
                        "defaultValue": "GLens_2G"
                    },
                    {
                        "key": "password",
                        "label": "Password",
                        "type": "password",
                        "placeholder": "Please Enter Password",
                        "required": true,
                        "defaultValue": "Hjy789"
                    },
                    {
                        "key": "ethernetDataPoll",
                        "label": "Ethernet Data Poll",
                        "type": "checkBox",
                        "required": true,
                        "checked": true,
                        "defaultValue": true,
                        "dependencyList": {
                            true: [
                                {
                                    "key": "ethernetIP",
                                    "label": "Ethernet IP",
                                    "type": "input",
                                    "placeholder": "Please Enter",
                                    "required": true,
                                    "tooltip": true,
                                    "tip": "Check"
                                },
                                {
                                    "key": "ethernetGateway",
                                    "label": "Ethernet Gateway",
                                    "type": "input",
                                    "dataType": "text",
                                    "placeholder": "Please Enter",
                                    "required": false,
                                    "defaultValue": "GLens_2G"
                                },
                                {
                                    "key": "ethernetSubnet",
                                    "label": "Ethernet Subnet",
                                    "type": "input",
                                    "dataType": "text",
                                    "placeholder": "Please Enter",
                                    "required": true,
                                    "defaultValue": "GLens_2G"
                                },
                                {
                                    "key": "ethernetDNS1",
                                    "label": "Ethernet DNS1",
                                    "type": "input",
                                    "dataType": "text",
                                    "placeholder": "Please Enter",
                                    "required": true,
                                    "defaultValue": "GLens_2G"
                                },
                                {
                                    "key": "ethernetDNS2",
                                    "label": "Ethernet DNS2",
                                    "type": "input",
                                    "dataType": "number",
                                    "placeholder": "Please Enter",
                                    "required": true,
                                    "defaultValue": 25
                                }
                            ],
                            false: []
                        },
                    }
                ]
            }
        }
    ]

    const validateNetworkFormData = () => {
        let valid = true;
        Object.entries(allRequiredFields)?.map((key: any, value) => {
            key[1]?.forEach((item: any, index: number) => {
                if (submitData[key[0]]) {
                    if (item?.required && item?.key) {
                        if (item?.key in submitData[key[0]]) {
                            // console.log(item?.key, submitData[key[0]][item?.key]);
                            if (item?.type === "addDynamicFields") {
                                if (rowsAPI?.length != submitData[key[0]][item?.key]?.length) {
                                    valid = false;
                                }
                                else {
                                    submitData[key[0]][item?.key]?.forEach((item: any, index: number) => {
                                        if (!item?.label || !item?.value) {
                                            valid = false;
                                        }
                                    })
                                }
                            }
                            else if (item?.disableDependency) {
                                console.log(item?.disableDependency)
                                if (submitData[key[0]][item?.disableDependency] === false) {
                                    // console.log(submitData[key[0]][item?.disableDependency])
                                }
                                else {
                                    if (!submitData[key[0]][item?.key]) {
                                        valid = false;
                                    }
                                }
                            }
                            else if (typeof (submitData[key[0]][item?.key]) === "boolean") {
                                if (submitData[key[0]][item?.key] === true || submitData[key[0]][item?.key] === false) {
                                }
                                else {
                                    valid = false;
                                }

                            }
                            else if (!submitData[key[0]][item?.key]) {
                                valid = false;
                            }
                        }
                        else {
                            if (item?.disableDependency) {
                                console.log(item?.disableDependency)
                                if (submitData[key[0]][item?.disableDependency] === false) {
                                    // console.log(submitData[key[0]][item?.disableDependency])
                                }
                                else {
                                    if (!submitData[key[0]][item?.key]) {
                                        valid = false;
                                    }
                                }
                            }
                            else {
                                valid = false;
                            }
                        }
                    }
                }
                else {
                    // (Object.keys(inputFormData)?.length) && (Object.keys(inputFormData)?.length === 0 || undefined)
                    valid = false;
                }
            })
        })

        // requiredFieldData?.forEach((item: any, index: number) => {
        //     if (inputFormData) {
        //         if (item?.required && item?.key) {
        //             if (item?.key in inputFormData) {
        //                 if (item?.type === "addDynamicFields") {
        //                     if (rowsAPI?.length != inputFormData[item?.key]?.length) {
        //                         valid = false;
        //                     }
        //                     else {
        //                         inputFormData[item?.key]?.forEach((item: any, index: number) => {
        //                             if (!item?.label || !item?.value) {
        //                                 valid = false;
        //                             }
        //                         })
        //                     }
        //                 }
        //                 else if (!inputFormData[item?.key]) {
        //                     valid = false;
        //                 }
        //                 else {
        //                     // console.log(inputFormData[item?.key]);
        //                 }
        //             }
        //             else {
        //                 valid = false;
        //             }
        //         }
        //     }
        //     else {
        //         // (Object.keys(inputFormData)?.length) && (Object.keys(inputFormData)?.length === 0 || undefined)
        //         valid = false;
        //     }
        // })
        return valid;
    }

    const checkEntireFormData = () => {
        let valid = true;
        let emptyModuleString: string = "";
        Object.entries(submitData)?.map((key: any, index: any) => {
            if (Object.keys(key[1])?.length === 0) {
                valid = false;
                if (index + 1 === Object.keys(submitData)?.length) {
                    emptyModuleString = emptyModuleString + key[0];
                }
                else {
                    emptyModuleString = emptyModuleString + key[0] + ", ";
                }
            }
        })
        console.log(valid);
        if (!valid) {
            alertService.serviceErrorMessage("Please check " + emptyModuleString)
        }
        return valid;
    }

    const onChangeADC = (event: any, key: any) => {
        let name: any = event.target.name;
        let temp = JSON.parse(JSON.stringify(moduleConfigData));
        temp.ADC[key][name] = Number(event.target.value);
        setModuleConfigData(temp);
        submitData["ADC"] = temp;
        setSubmitData(submitData);
    }

    const onSave = () => {
        if (checkEntireFormData()) {
            if (validateNetworkFormData()) {
                // console.log(submitData);
                updateModuleConfigData();
            }
            else {
                alertService.serviceWarningMessage("Please fill all required fields")
                console.log(submitData);
            }
        }
        setFinalSubmit(true);
        onSubmit && onSubmit();
    }


    return (
        <div className="log">
            <div className={classNames("modal-body py-3 events-none",
                {
                    "drawer-body": windowSize$ === "sm" || windowSize$ === "xs",
                    "dr": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                })} >
                <div>
                    {moduleConfigData && !loader ?
                        <div className="row">
                            <div className="col-3 nav-data">
                                <ul className="nav flex-column">
                                    {
                                        sunMenuItems.map(({ keyName, Label }) => (
                                            <>
                                                {Object.keys(moduleConfigData)?.length && Object.entries(moduleConfigData)?.map(([key, value]) => {
                                                    return (
                                                        <>
                                                            {key === keyName &&
                                                                <li
                                                                    className={classNames("nav-item pointer",
                                                                        { "active": activeSetting === keyName }
                                                                    )}
                                                                    onClick={() => { setActiveSetting(keyName) }}
                                                                >
                                                                    <a className="nav-link">
                                                                        <span className="side-menu-label">{Label}</span>
                                                                    </a>
                                                                </li>
                                                            }
                                                        </>
                                                    )
                                                })}
                                            </>
                                        ))
                                    }
                                </ul>
                            </div >
                            <div className="col-9" >
                                {
                                    <div className={classNames(
                                        { "d-none": activeSetting !== Constants.Meta }
                                    )}>
                                        {moduleConfigData?.meta?.map((item: any) => {
                                            return (
                                                <div className="row">
                                                    <div className="col-md-3 settings-label">{item?.label}</div>
                                                    <div className="col-md-9">: {item?.value}</div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                }
                                {
                                    <div className={classNames("row",
                                        { "d-none": activeSetting !== Constants.AdcConfig }
                                    )} >
                                        {Object.entries(moduleConfigData?.ADC)?.map(([key, value]) => {
                                            return (
                                                <div className="col-md-6 col-sm-12 row m-0">
                                                    <div className="col-md-12 mb-2 center-align settings-label">{key}</div>
                                                    <div className="col-md-12 mb-4">
                                                        <div className="mb-2">
                                                            <label >
                                                                <span className="settings-label">Read High :</span>
                                                            </label>
                                                            <input
                                                                className="form-control form-control-bordered w-75"
                                                                type="number"
                                                                name="rh"
                                                                onChange={(e) => { onChangeADC(e, key) }}
                                                                defaultValue={value?.rh}
                                                            />
                                                            {finalSubmit && !value?.rh &&
                                                                <div className="error-text">
                                                                    Please Enter Read High
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="mb-2">
                                                            <label >
                                                                <span className="settings-label">Read Low :</span>
                                                            </label>
                                                            <input
                                                                className="form-control form-control-bordered w-75"
                                                                type="number"
                                                                name="rl"
                                                                onChange={(e) => { onChangeADC(e, key) }}
                                                                defaultValue={value?.rl}
                                                            />
                                                            {finalSubmit && !value?.rl &&
                                                                <div className="error-text">
                                                                    Please Enter Read Low
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        }
                                    </div>
                                }
                                {
                                    <div className={classNames(
                                        { "d-none": activeSetting !== Constants.Network }
                                    )}
                                    >
                                        <FormBuilder
                                            config={moduleConfigData?.Network}
                                            finalSubmit={finalSubmit}
                                            rowsAPI={rowsAPI}
                                            setRowsAPI={setRowsAPI}
                                            setInputFormData={(e) => { carrySetInputFormData(e, "Network") }}
                                            setRequiredFieldData={(e) => { carrySetRequiredFieldData(e, "Network") }}
                                            requestedPage="deviceSettings"
                                        />

                                    </div>
                                }
                                {
                                    <div className={classNames(
                                        { "d-none": activeSetting !== Constants.AdvancedOptions }
                                    )}>
                                        <FormBuilder
                                            config={moduleConfigData?.advancedOptions}
                                            finalSubmit={finalSubmit}
                                            setInputFormData={(e) => { carrySetInputFormData(e, "advancedOptions") }}
                                            setRequiredFieldData={(e) => { carrySetRequiredFieldData(e, "advancedOptions") }}
                                            setRowsAPI={setRowsAPI}
                                            requestedPage="deviceSettings"
                                        />
                                    </div>
                                }
                            </div >
                        </div>
                        :
                        <Loader hasError={false} />
                    }
                </div >
            </div >
            <div className="no-border-footer modal-footer justify-content-center" >
                <div className="dis">
                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={() => onClose && onClose(false)}>Close</button>
                    <button attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" onClick={onSave}>Save Device Settings</button>
                </div>
            </div>
        </div >
    )
}
export default DeviceSettings;